<button
  class="loren-notifications-button-container"
  [matTooltip]="'tooltips.notifications' | transloco"
  [tourAnchor]="notificationsAnchorId"
  (click)="handleNotificationsClick()">
  <button class="loren-notifications-button" [ngClass]="{ 'ml-2': isHandset }">
    <span [matBadge]="notSeenNotifications" [matBadgeHidden]="!notSeenNotifications">
      <mat-icon class="loren-notifications-button-icon">
        {{ notSeenNotifications === 0 ? "notifications" : "notifications_active" }}
      </mat-icon>
    </span>
  </button>
  @if(!isHandset) {
  <span class="loren-notifications-button-text">{{
    "toolbar.notifications" | transloco
  }}</span>
  }
</button>
